'use client'

import { Button } from '@src/components/Button/Button'
import type { SKUSelectionCtaProps } from '@src/components/SKUSelectionCta/SKUSelectionCta.props'
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore'
import { filterBuilderAttributes } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

export const SKUSelectionCta = (props: SKUSelectionCtaProps) => {
  const { copy, redirectUrl, extraSkus, attributes, bundleId } = props
  const groups = useSKUSelectionStore((state) => state.groups)
  const groupRestrictions = useSKUSelectionStore((state) => state.groupRestrictions)

  const isValid = isSelectionStateValid(groups, groupRestrictions)

  const { className, ...buttonAttributes } = filterBuilderAttributes(attributes)

  return (
    <Button
      actionName="addSelectedSKUsToCart"
      addSelectedSKUsToCart={{
        redirectUrl,
        extraSkus,
        bundleId,
      }}
      variant={!isValid ? 'dark' : 'primary'}
      size="medium"
      className={cn('mt-auto w-full lg:mt-0 lg:w-auto', className)}
      {...buttonAttributes}
    >
      {copy}
    </Button>
  )
}
